<template>
    <section id="nostros" class="about">
      <h1>Acerca de Nosotros2</h1>
      <p>Somos una empresa dedicada a brindar soluciones innovadoras.</p>
    </section>
  </template>
  
  <script>
  export default {
    name: 'AboutPage',
  };
  </script>
  
  <style scoped>
  .about {
    text-align: center;
    padding: 5rem 2rem;
    background-color: #fff;
  }
  
  .about h1 {
    font-size: 3rem;
    color: #333;
  }
  
  .about p {
    font-size: 1.2rem;
    color: #666;
  }
  </style>
  